import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';
import { Person } from './person';

@inheritSerialization(AbstractApproval)
export class ApprovalObjectStatus extends AbstractApproval {
  @autoserialize
  object: string;

  @autoserialize
  status: string;

  @autoserialize
  backdated: boolean;

  @autoserializeAs(Person)
  requester: Person;

  @autoserializeAs(Person)
  reviewers: Array<Person>;

  getEffectiveDate(): Date {
    if (!isNullOrUndefined(this.object['effectiveDate'])) {
      return DateUtil.deserializeInstant(this.object['effectiveDate']);
    }
  }
}
